// extracted by mini-css-extract-plugin
module.exports = {"Title":"BackArrowTitle_Title__2RUjY"};